/* Copyright (c) 2021 MOCA Systems, Inc.  All rights reserved. */

import { AngularFireAction, DatabaseSnapshot } from '@angular/fire/compat/database';

import { PlanAccess, ILegacyIPlanAccessFields } from 'src/app/app-data/models/PlanAccess';
import { FancyFirebaseSplitDataList } from '../generics/FancyFirebaseSplitDataList';
import { AngularLandConnection, RefOrObservable } from '../base/interfaces';
import { DefaultSplitDataRenderType, IPlanAccessFields } from '@touchplan/common';

export class PlanAccessList extends FancyFirebaseSplitDataList<
	IPlanAccessFields,
	DefaultSplitDataRenderType,
	PlanAccess
> {
	constructor(angularLand: AngularLandConnection, path: RefOrObservable, fancyJoins?: any) {
		//fix any's
		super(angularLand, path, fancyJoins);
	}

	public $$added(action: AngularFireAction<DatabaseSnapshot<any>>) {
		const planAccess = new PlanAccess(action.payload.key);
		let data = action.payload.val();
		planAccess.databaseUpdate(data);
		return planAccess;
	}
}
